<template>
  	<div class='appContent'>
	       <transition name="router-fade" mode="out-in" v-if="$route.meta.keepAlive">
			<keep-alive>
			    <router-view ></router-view>
			</keep-alive>
    	       </transition>
    	       <transition name="router-fade" mode="out-in" v-if="!$route.meta.keepAlive">
			<router-view ></router-view>
	      </transition>
         </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.appContent{
   height:100%
}
</style>



// WEBPACK FOOTER //
// src/App.vue